module.exports = __webpack_public_path__ + "img/SKMA_emergency3.b0e5c7a7.jpg";